/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit_TitleInputs */

const en_sorter_pit_title = /** @type {(inputs: Sorter_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common Pitfalls`)
};

const ko_sorter_pit_title = /** @type {(inputs: Sorter_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자주 겪는 함정`)
};

const ja_sorter_pit_title = /** @type {(inputs: Sorter_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある落とし穴`)
};

/**
* | output |
* | --- |
* | "Common Pitfalls" |
*
* @param {Sorter_Pit_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit_title = /** @type {((inputs?: Sorter_Pit_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit_title(inputs)
	if (locale === "ko") return ko_sorter_pit_title(inputs)
	return ja_sorter_pit_title(inputs)
});